// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Remove blue hover background from autocomplete suggestions */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  box-shadow: 0 0 0 30px transparent inset !important;
  -webkit-text-fill-color: white !important;
  color: white !important;
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
  background-color: transparent !important;
}

/* Remove credentials picker icon styling */
input::-webkit-credentials-auto-fill-button {
  visibility: hidden;
  pointer-events: none;
  position: absolute;
  right: 0;
}

/* Style the input to prevent browser default styling */
input[type='email'],
input[type='password'],
input[type='text'] {
  background-color: transparent !important;
}

input[type='email']:focus,
input[type='password']:focus,
input[type='text']:focus {
  background-color: transparent !important;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,+DAA+D;AAC/D;;;;EAKE,mDAAmD;EACnD,yCAAyC;EACzC,uBAAuB;EACvB,yDAAiD;EAAjD,iDAAiD;EACjD,wCAAwC;AAC1C;;AAEA,2CAA2C;AAC3C;EACE,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,QAAQ;AACV;;AAEA,uDAAuD;AACvD;;;EAGE,wCAAwC;AAC1C;;AAEA;;;EAGE,wCAAwC;AAC1C","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Remove blue hover background from autocomplete suggestions */\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active {\n  -webkit-box-shadow: 0 0 0 30px transparent inset !important;\n  box-shadow: 0 0 0 30px transparent inset !important;\n  -webkit-text-fill-color: white !important;\n  color: white !important;\n  transition: background-color 5000s ease-in-out 0s;\n  background-color: transparent !important;\n}\n\n/* Remove credentials picker icon styling */\ninput::-webkit-credentials-auto-fill-button {\n  visibility: hidden;\n  pointer-events: none;\n  position: absolute;\n  right: 0;\n}\n\n/* Style the input to prevent browser default styling */\ninput[type='email'],\ninput[type='password'],\ninput[type='text'] {\n  background-color: transparent !important;\n}\n\ninput[type='email']:focus,\ninput[type='password']:focus,\ninput[type='text']:focus {\n  background-color: transparent !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
